<template>
    <div id="app">
        <console-app v-if="accessToken" title="MEVN2 관리자 메뉴">
            <router-view/>
        </console-app>
        <console-sign-in v-else />
    </div>
</template>

<script>
import ConsoleApp from "@/components/console/console-app.vue";
import ConsoleSignIn from "@/components/console/console-sign-in.vue";

export default {
    components: {
        ConsoleApp,
        ConsoleSignIn
    },
    computed: {
        accessToken(){
            return this.$store.state.accessToken;
        },
        payload(){
            return this.$store.state.payload;
        }
    }
}
</script>
